import styled from 'styled-components';
import Row from '../../Row';
import Popup from '../PopupOverlay';
import { useApp } from '../../../contexts/AppContext';
import { isMeerkatEvent } from '../../../lib/events';
import { useNavigate } from 'react-router-dom';

const Header = styled.div`
  text-align: center;
  font-size: 70px;
  font-weight: 500;
  margin: 25px 0 70px;
  font-family: 'Krungthep';
  color: #efff00;
`;

const Text = styled.div`
  color: #fff;
  text-align: center;
  font-size: 36px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
`;

const Meerkat = () => {
  const { event } = useApp();
  const navigate = useNavigate();

  if (!isMeerkatEvent(event)) throw new Error('Should not happen');

  return (
    <Popup close="Great!" onConfirm={async () => navigate('/friends/note')}>
      <Row>
        <img alt="meerkat" src="/img/Meerkat.png" style={{ width: '500px', marginTop: '-400px' }} />
      </Row>
      <Header>Congratulations</Header>
      <Row margin="70px 0">
        <Text>
          Once the verification is completed, you will receive a Treasure Box! This may take some time if there are a
          lot of people interested.
          <br />
          <br />
          Invite your friends to the game and boost the level of your Treasure Box!
        </Text>
      </Row>
    </Popup>
  );
};

export default Meerkat;
